// extracted by mini-css-extract-plugin
module.exports =  {"infoContainer":"PageCreatedBanner-PageCreatedBanner-infoContainer-d8f7554c","text":"PageCreatedBanner-PageCreatedBanner-text-bb0e814a"};